import { Trans } from '~/common/context';
import { Button, Flex, Icon, Text, Tooltip } from '@wyz/ui';
import { CarFeatureIcon } from '~/purchase/components';

import { TYRE_SPEC_ENUM } from '~/purchase/schemas';
import { IBaseTyreOffer } from '~/purchase/types';
import { isNil } from 'lodash-es';

type Props = {
  product: Pick<
    IBaseTyreOffer,
    | 'status'
    | 'totalAvailableQuantity'
    | 'tyre'
    | 'tyreCreatedAt'
    | 'alternativeCount'
    | 'canOrder'
  >;
  onDetail: () => void;
};

function OfferDescriptionCell({ product, onDetail }: Props) {
  return (
    <div className='d-flex justify-content-center flex-column'>
      <div className='p-2 text-center'>
        <Text heading='xs' weight='semi-bold' color='secondary'>
          {product.tyre.prodInfo && (
            <>
              {!isNil(product.tyre.homologations) &&
              product.tyre.homologations.length !== 0 ? (
                <Tooltip
                  label={product.tyre.homologations
                    .map((homologation) => homologation.brand)
                    .join(', ')}
                >
                  <span>{product.tyre.prodInfo}</span>
                </Tooltip>
              ) : (
                <span>{product.tyre.prodInfo}</span>
              )}
            </>
          )}
        </Text>

        <Tooltip label='Run flat'>
          <Text heading='xs' weight='semi-bold' color='secondary'>
            {product.tyre.specification.rftext}
          </Text>
        </Tooltip>
        <Text color='primary'>
          <Flex alignItems='center' justifyContent='center'>
            {product.tyre.specification.electricId !==
              TYRE_SPEC_ENUM.ELECTRIC.DISABLED && (
              <Tooltip
                label={
                  <Trans i18nKey='app.purchase.search_page.filter.specificities.electric' />
                }
              >
                <span>
                  <CarFeatureIcon value='electric' size='xs' />
                </span>
              </Tooltip>
            )}
            {product.tyre.specification.eco === TYRE_SPEC_ENUM.ECO.ENABLED && (
              <Tooltip
                label={
                  <Trans i18nKey='app.purchase.search_page.filter.specificities.eco' />
                }
              >
                <span>
                  <CarFeatureIcon value='eco' size='xs' />
                </span>
              </Tooltip>
            )}
            {Boolean(product.tyre.specification.sportCompatibility) && (
              <Tooltip
                label={
                  <Trans i18nKey='app.purchase.search_page.filter.specificities.sport' />
                }
              >
                <span>
                  <CarFeatureIcon value='sport' size='xs' />
                </span>
              </Tooltip>
            )}
          </Flex>
        </Text>
      </div>

      <Button
        id={`${product.tyre.ean}-detail`}
        variant='tertiary-blue'
        size='xs'
        onClick={onDetail}
      >
        <Text
          component={Flex}
          heading='xs'
          weight='semi-bold'
          color='primary'
          alignItems='center'
          className='space-x-1'
        >
          <span>
            <Trans i18nKey='app.purchase.table.info_btn' />
          </span>
          <Icon icon='eye' size='xs' />
        </Text>
      </Button>
    </div>
  );
}

export default OfferDescriptionCell;
